// Templates padrão e metadados das notificações
export const NOTIFICATION_SECTIONS = [
  {
    title: 'Notificações antes do vencimento da cobrança',
    items: [
      { id: 'new_charge', label: 'Aviso de criação de novas cobranças', defaultEmail: true, defaultSms: true },
      { id: 'update_charge', label: 'Aviso de alteração no valor ou data de vencimento das cobranças', defaultEmail: true, defaultSms: false },
      { id: 'due_reminder', label: 'Aviso de vencimento: 5, 10, 15 ou 30 dias antes do vencimento', defaultEmail: true, defaultSms: true },
      { id: 'due_today', label: 'Enviar cobranças pendentes no dia do vencimento', defaultEmail: true, defaultSms: true },
      { id: 'boleto_line', label: 'Enviar linha digitável do boleto caso o cliente não o tenha impresso', defaultEmail: true, defaultSms: false }
    ]
  },
  {
    title: 'Notificações de cobranças vencidas',
    items: [
      { id: 'overdue_warning', label: 'Aviso sobre atrasos e falhas nos pagamentos', defaultEmail: true, defaultSms: true },
      { id: 'recurring_overdue', label: 'Relembrar cobranças vencidas a cada 1, 3, 7, 15 ou 30 dia(s) após o vencimento', defaultEmail: true, defaultSms: true }
    ]
  },
  {
    title: 'Notificações de cobranças pagas',
    items: [
      { id: 'payment_confirmed', label: 'Aviso quando os pagamentos forem confirmados', defaultEmail: true, defaultSms: true }
    ]
  },
  {
    title: 'Notificações de comunicação',
    items: [
      { id: 'charge_deleted', label: 'Aviso de exclusão de cobranças', defaultEmail: true, defaultSms: false }
    ]
  }
];

export const AVAILABLE_VARIABLES = [
  { code: '{{data_vencimento}}', label: 'Data do vencimento' },
  { code: '{{descricao_cobranca}}', label: 'Descrição da cobrança' },
  { code: '{{nome_cliente}}', label: 'Nome do cliente' },
  { code: '{{quantidade_parcelas}}', label: 'Quantidade de parcelas' },
  { code: '{{sua_empresa}}', label: 'Nome da sua empresa' },
  { code: '{{valor_parcela}}', label: 'Valor da parcela' },
  { code: '{{valor_total_cobranca}}', label: 'Valor total da cobrança ou soma das parcelas quando parcelado' },
  { code: '{{link_cobranca}}', label: 'Link da cobrança' },
  { code: '{{link_publico}}', label: 'Link público da cobrança' }
];

export const defaultTemplates = {
  email: {
    new_charge: {
      subject: 'Nova cobrança gerada - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nUma nova cobrança foi gerada para você no valor de {{valor_total_cobranca}}.\n\nVencimento: {{data_vencimento}}\n\nVocê pode acessar a cobrança pelo link: {{link_cobranca}}'
    },
    update_charge: {
      subject: 'Atualização na sua cobrança - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nHouve uma alteração na sua cobrança de {{descricao_cobranca}}.\n\nNovo valor: {{valor_total_cobranca}}\nNovo vencimento: {{data_vencimento}}'
    },
    due_reminder: {
      subject: 'Lembrete de vencimento - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nLembramos que sua fatura vence em breve ({{data_vencimento}}).\n\nValor: {{valor_total_cobranca}}\n\nAcesse: {{link_cobranca}}'
    },
    due_today: {
      subject: 'Sua fatura vence hoje - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nSua fatura vence hoje!\n\nValor: {{valor_total_cobranca}}\n\nEvite juros pagando agora: {{link_cobranca}}'
    },
    boleto_line: {
      subject: 'Linha digitável do seu boleto - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nAqui está a linha digitável para pagamento do seu boleto:\n\n{{linha_digitavel}}\n\nValor: {{valor_total_cobranca}}'
    },
    overdue_warning: {
      subject: 'Aviso de atraso - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nNão identificamos o pagamento da sua fatura vencida em {{data_vencimento}}.\n\nPor favor, regularize sua situação: {{link_cobranca}}'
    },
    recurring_overdue: {
      subject: 'Cobrança em aberto - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nSua fatura continua em aberto.\n\nEvite bloqueios e juros adicionais.\n\nPague agora: {{link_cobranca}}'
    },
    payment_confirmed: {
      subject: 'Pagamento confirmado - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nRecebemos seu pagamento de {{valor_total_cobranca}} com sucesso!\n\nObrigado por ser nosso cliente.'
    },
    charge_deleted: {
      subject: 'Cobrança cancelada - {{sua_empresa}}',
      content: 'Olá, {{nome_cliente}}.\n\nA cobrança de {{valor_total_cobranca}} ({{descricao_cobranca}}) foi cancelada e removida do nosso sistema.'
    }
  },
  whatsapp: {
    new_charge: 'Olá, {{nome_cliente}}. Nova cobrança de {{sua_empresa}} gerada. Valor: {{valor_total_cobranca}}. Vencimento: {{data_vencimento}}. Link: {{link_cobranca}}',
    update_charge: '{{nome_cliente}}, sua cobrança de {{descricao_cobranca}} foi atualizada. Novo valor: {{valor_total_cobranca}}. Vencimento: {{data_vencimento}}.',
    due_reminder: 'Oi {{nome_cliente}}! Lembrete: sua fatura vence em {{data_vencimento}}. Valor: {{valor_total_cobranca}}. Link: {{link_cobranca}}',
    due_today: '{{nome_cliente}}, sua fatura vence HOJE! Valor: {{valor_total_cobranca}}. Pague agora: {{link_cobranca}}',
    boleto_line: 'Linha digitável do boleto: {{linha_digitavel}}',
    overdue_warning: '{{nome_cliente}}, não identificamos seu pagamento vencido em {{data_vencimento}}. Regularize: {{link_cobranca}}',
    recurring_overdue: '{{nome_cliente}}, sua fatura continua pendente. Evite juros: {{link_cobranca}}',
    payment_confirmed: 'Pagamento recebido! Obrigado, {{nome_cliente}}. Valor: {{valor_total_cobranca}}.',
    charge_deleted: 'A cobrança de {{valor_total_cobranca}} foi cancelada.'
  }
};
